export default {
      id: "file-pdf-usage",
      viewBox: "0 0 384 512",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#file-pdf",
      toString: function () {
        return this.url;
      }
    }